const assignmentTypes = {
  3: "School",
  5: "Class",
  6: "Individual",
};

export default assignmentTypes;
